import React from "react"
import cn from "design_system/libs/cn"

interface Avatar {
  id: string
  name: string
  imageUrl: string
}

interface AvatarGridProps {
  avatars: Avatar[]
  selectedId: string | null
  onSelect: (id: string) => void
  disabled?: boolean
}

export function AvatarGrid({
  avatars,
  selectedId,
  onSelect,
  disabled = false,
}: AvatarGridProps) {
  if (avatars.length === 0) {
    return (
      <p className="text-gray-500 text-sm py-4">
        No avatars available. Complete quests to unlock more!
      </p>
    )
  }

  return (
    <div className="grid grid-cols-4 gap-2">
      {avatars.map((avatar) => {
        const isSelected = selectedId === avatar.id

        return (
          <button
            key={avatar.id}
            type="button"
            onClick={() => onSelect(avatar.id)}
            disabled={disabled}
            className={cn(
              "relative aspect-square rounded-lg border-2 p-1 transition-all",
              "hover:border-primary-400 hover:shadow-md",
              "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              isSelected
                ? "border-primary-500 bg-primary-50 ring-2 ring-primary-500"
                : "border-gray-200 bg-white"
            )}
            title={avatar.name}
          >
            <img
              src={avatar.imageUrl}
              alt={avatar.name}
              className="w-full h-full object-contain pixel-art"
            />
            {isSelected && (
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-primary-500 rounded-full flex items-center justify-center">
                <svg
                  className="w-3 h-3 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default AvatarGrid
